import React from 'react';

interface Props {
  current: string;
  onNavigate: (page: string, params?: Record<string, string>) => void;
  isAuthed: boolean;
  currentUsername?: string | null;
}

export function BottomNav({ current, onNavigate, isAuthed, currentUsername }: Props) {
  const TABS = [
    { id: 'feed',          label: 'Feed',    icon: HomeIcon },
    { id: 'search',        label: 'Search',  icon: SearchIcon },
    { id: 'post',          label: '',        icon: ComposeIcon },
    { id: 'colors',        label: 'Colors',  icon: ColorIcon },
    ...(isAuthed
      ? [{ id: 'notifications', label: 'Alerts', icon: BellIcon }]
      : [{ id: 'login',         label: 'Sign in', icon: ProfileIcon }]
    ),
  ];

  return (
    <nav className="bottom-nav" style={{ alignItems: 'center', justifyContent: 'space-around' }}>
      {TABS.map(tab => {
        const active = current === tab.id;
        const Icon = tab.icon;
        const isPost = tab.id === 'post';
        const isLogin = tab.id === 'login';

        if (isLogin) {
          return (
            <a
              key={tab.id}
              href="/api/v1/auth/login"
              style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, height: '100%', gap: 3, textDecoration: 'none' }}
            >
              <Icon size={22} color="var(--text-muted)" />
              <span style={{ fontSize: 10, color: 'var(--text-muted)' }}>Sign in</span>
            </a>
          );
        }

        return (
          <button
            key={tab.id}
            onClick={() => {
              const handle = currentUsername && currentUsername !== 'null' ? currentUsername : null;
              if (tab.id === 'profile' && handle) {
                onNavigate('user', { username: handle });
              } else {
                onNavigate(tab.id);
              }
            }}
            aria-label={tab.label || 'New post'}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', flex: 1, height: '100%', gap: 3 }}
          >
            {isPost ? (
              <span style={{ width: 46, height: 46, borderRadius: '50%', background: 'var(--accent)', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 16px var(--accent-glow)' }}>
                <Icon size={22} />
              </span>
            ) : (
              <>
                <Icon size={22} color={active ? 'var(--accent)' : 'var(--text-muted)'} />
                {tab.label && <span style={{ fontSize: 10, color: active ? 'var(--accent)' : 'var(--text-muted)' }}>{tab.label}</span>}
              </>
            )}
          </button>
        );
      })}
    </nav>
  );
}

function HomeIcon({ size = 24, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/>
      <path d="M9 21V12h6v9"/>
    </svg>
  );
}

function ColorIcon({ size = 24, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="9"/>
      <path d="M12 3a9 9 0 010 18" fill={color} opacity="0.15"/>
      <circle cx="8"  cy="10" r="1.5" fill={color} stroke="none"/>
      <circle cx="16" cy="10" r="1.5" fill={color} stroke="none" opacity="0.6"/>
      <circle cx="12" cy="15" r="1.5" fill={color} stroke="none" opacity="0.35"/>
    </svg>
  );
}

function ComposeIcon({ size = 22, color = '#fff' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={2.2} strokeLinecap="round">
      <line x1="12" y1="5" x2="12" y2="19"/>
      <line x1="5" y1="12" x2="19" y2="12"/>
    </svg>
  );
}

function SearchIcon({ size = 24, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  );
}

function BellIcon({ size = 24, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 01-3.46 0"/>
    </svg>
  );
}

function ProfileIcon({ size = 24, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="8" r="4"/>
      <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/>
    </svg>
  );
}
